import { IframeWindow } from '.';
import { schema } from '../../api/schema';

export class Schema implements schema.Api {
  constructor(private iframe: IframeWindow) {}

  customiseList(request: schema.CustomiseListRequest): Promise<schema.CustomiseListResponse> {
    return this.iframe.twoWayCall<schema.CustomiseListRequest, schema.CustomiseListResponse>(
      request,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'schema.customiseList',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => {
        return response;
      }
    );
  }

  getLists(request: schema.GetListsRequest): Promise<schema.SchemaResponse<schema.SchemaList[]>> {
    return this.iframe.twoWayCall<schema.GetListsRequest, schema.SchemaResponse<schema.SchemaList[]>>(
      request,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'schema.getLists',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => {
        return response;
      }
    );
  }
}
